import React, { useState, useEffect } from "react";
import Icon from "../../../../component/Icon";
import { girl } from "../../../../assets/images/images";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { axiosInstance as axios } from "../../../../axios/axios";
import { Bars } from "react-loader-spinner";
const ViewUser = () => {
  const state = useSelector((state) => state.auth);
  const [user, setUser] = useState(null);

  const params = useParams();
  useEffect(() => {
    (async () => {
      try {
        const config = {
          headers: {
            authorization: `Bearer ${state.token}`,
          },
        };
        const res = await axios.get(
          `/api/dashboard/users/${params.id}`,
          config
        );
        setUser(res.data.data);
      } catch (err) {
        console.log(err.message);
      }
    })();
  }, []);
  if (!user)
    return (
      <div className="flex flex-col items-center justify-center min-h-[25rem]">
        <Bars height={25} color="#3b82f6" margin="0 auto" />
        <h1 className=" text-sm text-gray-400 mt-2">Please wait...</h1>
      </div>
    );
  return (
    <div className="min-h-[15rem] w-[60%] mx-auto  flex  items-center justify-center p-8 shadow-2xl relative font-Poppins">
      <div className="absolute top-2 left-4 flex items-center gap-2 ">
        <button className="w-8 h-8 bg-blue-400 hover:opacity-80 flex justify-center items-center rounded-md">
          <Icon name="eye-solid" className="w-[1rem] h-[1rem] fill-white" />
        </button>
        <h1>User Profile</h1>
      </div>
      <h1 className="absolute top-14 right-14">User id:{user.id}</h1>
      <h1 className="absolute top-14 left-4">Personal Information</h1>

      <div className="flex w-full h-full gap-[2rem] mt-[6rem] ">
        <div className="  w-[40%]  h-[12rem]">
          <img src={girl} alt="" className="w-full h-full object-contain" />
        </div>
        <div className="w-[60%] font-Poppins font-[400] ">
          <div className="flex flex-row gap-x-8 mt-4 w-full">
            <div className="w-[60%]">
              <h1>Firstname</h1>
              <h1>{user.firstname}</h1>
            </div>
            <div className="w-[40%]">
              <h2>Lastname</h2>
              <h2>{user.lastname}</h2>
            </div>
          </div>
          <div className="flex flex-row gap-x-8  mt-4 w-full">
            <div className="w-[60%]">
              <h1>Email</h1>
              <h1 className="block">{user.email}</h1>
            </div>
            <div className="w-[40%]">
              <h2>Phone</h2>
              <h2>{user.phone}</h2>
            </div>
          </div>
          <div className="flex flex-row gap-x-4 mt-4 w-full">
            <div className="w-1/2">
              <h1>Address</h1>
              <h1>{user.address}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUser;
